import { css } from '@emotion/react'

export const Opacity = (opacity: number) => css`
	opacity: ${opacity};
`

Opacity.Transparent = Opacity(0)
Opacity.Opaque = Opacity(1)
Opacity.Half = Opacity(0.5)
